// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.client.phoneverifier.enums.PhoneVerificationSource

export enum PhoneVerificationSource {
  ADMIN = 'ADMIN',
  LISTING_CLAIMING_PATH = 'LISTING_CLAIMING_PATH',
  LISTING_CONTACT = 'LISTING_CONTACT',
  OTP_RENT_PAYMENT = 'OTP_RENT_PAYMENT',
}

export const PhoneVerificationSource_values = [
  PhoneVerificationSource.ADMIN,
  PhoneVerificationSource.LISTING_CLAIMING_PATH,
  PhoneVerificationSource.LISTING_CONTACT,
  PhoneVerificationSource.OTP_RENT_PAYMENT,
] as const;
